import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { CheckOutline } from "@faire/web--source/slate/icons/foundation/CheckOutline";
import { Exclamation } from "@faire/web--source/slate/icons/foundation/Exclamation";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Toast/Toast#createToast"
 */ export var AppDownloadSuccessToast = function(props) {
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(CheckOutline, {
                    color: Core.icon.inverse,
                    fontSize: "24px"
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                align: "flex-start",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "hhmXIc",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Download link sent to "
                                },
                                {
                                    type: 1,
                                    value: "formattedPhoneNumber"
                                }
                            ],
                            values: {
                                formattedPhoneNumber: props.formattedPhoneNumber
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        tertiaryColor: Core.text.inverse,
                        onClick: props.onClick,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "TyaaRH",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Resend Link"
                                }
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Toast/Toast#createToast"
 */ export var AppDownloadFailureToast = function(props) {
    return /*#__PURE__*/ _jsxs(Row, {
        align: !isLoggedInRetailer() ? "center" : undefined,
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                $hideTryAgainButton: !isLoggedInRetailer(),
                children: /*#__PURE__*/ _jsx(Exclamation, {
                    color: Core.icon.inverse,
                    fontSize: "24px"
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "2x"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                align: "flex-start",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "orW+G5",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Error sending download link."
                                }
                            ]
                        })
                    }),
                    isLoggedInRetailer() ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: 4
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "tertiary",
                                tertiaryColor: Core.text.inverse,
                                onClick: props.onClick,
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "N2oCB6",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Try Again"
                                        }
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var IconWrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-b68925a6-0"
})([
    "flex-shrink:0;",
    ""
], function(props) {
    return !props.$hideTryAgainButton ? css([
        "width:",
        ";height:",
        ";"
    ], getSpacing("5x"), getSpacing("5x")) : null;
});
